import React, {
  FunctionComponent,
  PropsWithChildren,
  useCallback,
  useRef,
} from 'react'
import cn from 'classnames'
import styles from './InfoPopup.module.scss'
import { Icon } from '@/icons'
import { useDocumentClick } from '@/hooks/DOM'

interface InfoPopupProps {
  className?: string
  isVisible: boolean
  onClose?: () => void
  withoutCloseButton?: boolean
  closeOnClickOutside?: boolean
}
export const InfoPopup: FunctionComponent<
  PropsWithChildren<InfoPopupProps>
> = ({
  className,
  isVisible,
  onClose,
  withoutCloseButton = false,
  closeOnClickOutside = false,
  children,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)

  const onDocumentClick = useCallback(
    (e: MouseEvent) => {
      if (
        onClose != null &&
        closeOnClickOutside &&
        e.target instanceof Node &&
        !containerRef.current?.contains(e.target) &&
        isVisible
      ) {
        onClose()
      }
    },
    [onClose, isVisible, closeOnClickOutside]
  )

  useDocumentClick(onDocumentClick)

  return (
    <div
      ref={containerRef}
      className={cn(styles.container, className, {
        [styles.isVisible]: isVisible,
      })}
    >
      {!withoutCloseButton ? (
        <button onClick={onClose} className={styles.closeButton}>
          <Icon name="clear" stroke="#2C2C36" />
        </button>
      ) : null}
      {children}
    </div>
  )
}
